var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.addresses.length)?_c('div',[_c('deposit-movements-modal')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }